import PropTypes from 'prop-types';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { connect } from 'react-redux';
import { add, load } from '../../../reducers/subContractor/subContractor.actions';
import { subContractors, loading } from '../../../reducers/subContractor/subContractor.reducer';
import { Spinner } from '../../Spinner/Spinner';
import './AdminSubContractors.css';
import ConnectedSubContractorForm from './SubContractorForm/SubContractorForm';

export class AdminSubContractors extends React.Component {
  componentDidMount() {
    this.props.load();
  }

  render() {
    return (
      <span>
        <Spinner isLoading={this.props.areSubContractorsLoading} />
        <Row style={{ 'margin-bottom': '15px' }}><Col><Button onClick={this.props.addSubContractor} bsStyle="primary">Add New SubContractor</Button></Col></Row>
        {this.props.subContractors.map(subContractor => (
          <Row key={subContractor.id}>
            <Col>
              <ConnectedSubContractorForm subContractor={subContractor} />
            </Col>
          </Row>
          ))}
        <Row><Col><Button onClick={this.props.addSubContractor} bsStyle="primary">Add New SubContractor</Button></Col></Row>
      </span>
    );
  }
}

AdminSubContractors.propTypes = {
  load: PropTypes.func.isRequired,
  addSubContractor: PropTypes.func.isRequired,
  areSubContractorsLoading: PropTypes.bool.isRequired,
  subContractors: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

export const mapStateToProps = state => ({
  areSubContractorsLoading: loading(state),
  subContractors: subContractors(state),
});

export const mapDispatchToProps = dispatch => ({
  load: () => dispatch(load()),
  addSubContractor: () => dispatch(add()),
});

export default connect(mapStateToProps, mapDispatchToProps)(AdminSubContractors);



// WEBPACK FOOTER //
// ./src/components/Admin/SubContractor/AdminSubContractors.jsx